import React, { Component } from 'react';
import './ZoomButtons.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretLeft, faCaretUp, faCaretDown} from '@fortawesome/free-solid-svg-icons';
import IconButton from './IconButton';
import ParameterErrors from '../errors/ParameterErrors';
import HashSource from '../core/HashSource';
import Urls from '../urls/Urls';
import Tooltip from './Tooltip';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class ZoomButtons extends Component {
	constructor(props){
		super(props);
		const { min, max, initial, interval, onValueChanged} = props;
		this._value = initial;
		this._min = min;
		this._max = max;
		this._interval = interval;
		this._onValueChanged = onValueChanged;
		this._handleClickDown= this._handleClickDown.bind(this);
		this._handleClickUp= this._handleClickUp.bind(this);
		this.state = {visible:true, disabled:false};
	}
	setValue(value){
		this._value = value;
	}
	_handleClickUp(){
		this._value+=this._interval;
		if(this._value>this._max)
			this._value = this._max;
		this._onValueChanged(this._value);
	}
	_handleClickDown(){
		this._value-=this._interval;
		if(this._value<this._min)
			this._value = this._min;
		this._onValueChanged(this._value);
	}
	render() {
		let className = "zoom-buttons";
		if(this.state.visible)
			className+= " visible"
		return (
			<div className={className} ref={this._element}>
				<IconButton tooltip="Zoom In" className="up" imgUrl={Urls.assets+'icons/UI_Button_ZoomIn.png'} text="" disabled={this.state.disabled} onClick={this._handleClickUp} key={HashSource.next()}></IconButton>
				<IconButton tooltip="Zoom Out" className="down" imgUrl={Urls.assets+'icons/UI_Button_ZoomOut.png'} text="" disabled={this.state.disabled} onClick={this._handleClickDown} key={HashSource.next()}></IconButton>
			</div>
		)
	}
}